// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"88448ced","329":"eab1c34b","630":"3b3dbfd2","948":"385c974b"}[chunkId] + ".chunk.css";
};